<template>
  <div v-if="isOpen">
    <div class="ma__overlay" @click.prevent="$emit('toggle')"></div>
    <div :class="`ma__modalpopup ${className}`">
      <div class="ma__content">
        <div class="ma__close" @click.prevent="$emit('toggle')">
          <span>&times;</span>
        </div>
        <h2 class="title">{{ title }}</h2>
        <slot></slot>
      </div>
    </div>
  </div>  
</template>

<script>
export default {
  props: ['title', 'isOpen', 'className'],
}
</script>

<style lang="sass">
@import "../../../../styles/partials/variables" 

.ma__content
  h2.title
    font-weight: 600

</style>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/components/Utilities/Modal.vue